import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { ActionPlanEditionOptionsCell } from "../components/ActionPlanEditionOptionsCell";
import { ActionPlanNameCell } from "../components/ActionPlanNameCell";
import { ActionPlanStatusCell } from "../components/ActionPlanStatusCell";
import { ActionPlanDueDateCell } from "../components/ActionPlanDueDateCell";
import { ActionPlanOwnerCell } from "../components/ActionPlanOwnerCell";

interface IActionPlansTableColumns extends Omit<IMainTableColumn, "render"> {
    render: (row: IActionPlan) => string | JSX.Element | number;
}

interface IUseActionPlansTableColumnsProps {
    onDeleteActionPlan?: (actionPlan: IActionPlan) => void;
}

const useActionPlansTableColumns = (props?: IUseActionPlansTableColumnsProps): IActionPlansTableColumns[] => {
    const { t } = useTranslation();
    const { onDeleteActionPlan } = props || {};
    const columns = useMemo(
        (): IActionPlansTableColumns[] => [
            {
                id: "name",
                label: "",
                hideSortIcon: true,
                customStyles: { padding: "16px 8px", width: "35%" },
                render: (row) => <ActionPlanNameCell row={row} />,
            },
            {
                id: "status",
                label: t("rca.issues.issue_detail.action_plans.status"),
                hideSortIcon: true,
                customStyles: { padding: "16px 8px", width: "20%" },
                render: (row) => <ActionPlanStatusCell row={row} />,
            },
            {
                id: "dueDate",
                label: t("rca.issues.issue_detail.action_plans.due_date"),
                hideSortIcon: true,
                align: "center",
                customStyles: { padding: "16px 8px", width: "20%" },
                render: (row) => <ActionPlanDueDateCell row={row} />,
            },
            {
                id: "owner",
                label: "",
                hideSortIcon: true,
                align: "center",
                customStyles: { padding: "16px 8px", width: "5%" },
                render: (row) => <ActionPlanOwnerCell row={row} />,
            },
            {
                id: "actions",
                label: "",
                hideSortIcon: true,
                align: "center",
                customStyles: { padding: "16px 8px", width: "5%" },
                render: (row) => <ActionPlanEditionOptionsCell row={row} onDeleteActionPlan={onDeleteActionPlan} />,
            },
        ],
        [t, onDeleteActionPlan],
    );

    return columns;
};

export default useActionPlansTableColumns;
